import React, { useState, useEffect } from 'react'
import ConfirmationPopup from '../../../../presentationals/Popup/ConfirmationPopup.component';
import Popup from '../../../../presentationals/Popup/Popup.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import TextField from '@mui/material/TextField';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Pagination from '@mui/material/Pagination';

import { getAllrulesList, getAllrulesListByRuleId, DeleteRuleByRuleId, activateDeactivateRuleByType } from './ActionCreator';
import MenuBar from './MenuBar'
import AddRulesPopup from './AddRulesPopup';

const itemsPerPage = 10;
const zindex = {
    zIndex: '2'
};
export default function RulesListMain() {
    const [loader, setLoader] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const [apiData, setApiData] = useState([])
    const [FilterData, setFilterData] = useState([])
    const [currentPage, setcurrentPage] = useState(1)
    const [confirmPopup, setconfirmPopup] = useState({ show: false, data: {} })
    const [popup, setpopup] = useState({ show: false, popupStatus: {} })
    const [addPopup, setAddPopup] = useState(false);
    const [Editdata, setEditdata] = useState({});

    useEffect(() => {
        getAllrulesListFn()
    }, [])

    const handlesearchchange = (e) => {
        setSearchValue(e.target.value)
        if (e.target.value?.length == 0) {
            GetEmployeeToRuleFn()
        }
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value);
        filterFunction(apiData, value)
    };

    const filterFunction = (data, currentPageNo) => {
        const indexOfLastItem = currentPageNo * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
        setFilterData(currentItems)
    }

    const convertarrtostr = (data) => {
        if (Array.isArray(data) && data.length > 0) {
            return data.join(', ');
        }
        return '';
    }

    const getAllrulesListFn = () => {
        setLoader(true)
        getAllrulesList(callback => {
            setLoader(false)
            if (callback && callback?.length > 0) {
                setApiData(callback)
                setcurrentPage(1)
                filterFunction(callback, 1)
            } else {
                setApiData([])
            }
        })
    }



    const handlesearch = () => {
        setLoader(true)
        getAllrulesListByRuleId(searchValue, callback => {
            setLoader(false)
            setcurrentPage(1)
            let arr = [];
            arr.push(callback)
            setApiData(arr)
            setFilterData(arr)
        })
    }

    const handleclearsearch = () => {
        setSearchValue("")
        getAllrulesListFn()
    }

    const handleDelete = (data) => {
        setconfirmPopup({ show: true, data: data })
    }

    const cancelLoanConfirm = (type) => {
        if (type == "yes") {
            setLoader(true)
            DeleteRuleByRuleId(confirmPopup?.data?.id, callback => {
                setLoader(false)
                if (callback?.responseCode !== 0) {
                    setpopup({ show: true, popupStatus: "Rule Deleted succesfully" })
                    setconfirmPopup({ show: false, data: {} })
                    getAllrulesListFn()
                } else {
                    setpopup({ show: true, popupStatus: "Error Deleting Rule" })
                }
                removePopup()
            })

        } else {
            setconfirmPopup({ show: false, data: {} })
        }
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: "" })
    }
    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleAddPopup = (value) => {
        if (value == false) {
            getAllrulesListFn()
            setEditdata({})
        }
        setAddPopup(value)
    }

    const handleActivate = (type) => {
        const valueType = type?.active == false ? "activate" : type?.active == true ? "deactivate" : ""
        if (valueType !== "") {
            setLoader(true)
            activateDeactivateRuleByType(type?.id, valueType, callback => {
                setLoader(false)
                console.log("cal", callback)
                if (callback && callback?.id && callback?.active == !type?.active) {
                    setpopup({ show: true, popupStatus: `Success` })
                } else {
                    setpopup({ show: true, popupStatus: `Failure` })
                }
                removePopup()
            })
        } else {
            setpopup({ show: true, popupStatus: "Error Field Not Found" })
            removePopup()
        }
    }

    const handleEditValues = (data) => {
        setEditdata(data)
         setAddPopup(true)
    }

    return (
        <>
            {
                loader ?
                    <Loader />
                    : ''
            }

            {
                confirmPopup?.show ?
                    <ConfirmationPopup cancelLoanConfirm={cancelLoanConfirm} confirmationText={'Are You Sure, You Want to Delete this Rule'} customStyle={zindex} />
                    : ''}

            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                    : ''}

            <div className="row" style={{ marginTop: '30px' }}>
                <div className="col-sm-2">
                    <TextField fullWidth id="outlined-basic" label="Search by Rule Name" variant="outlined"
                        sx={{
                            ".MuiInputLabel-formControl": {
                                background: '#fff'
                            }
                        }}
                        type='email'
                        value={searchValue}
                        onChange={(e) => handlesearchchange(e)}
                    />
                </div>
                <div className="col-sm-3">
                    <button className="btn btn-primary" style={{ marginBottom:'0',width: '100%', padding: '12.5px', maxWidth: '90px' }} disabled={searchValue?.length > 0 ? false : true} onClick={() => handlesearch()}>Filter</button>
                    {
                        searchValue?.length > 0 ?
                            <button className="btn reset-btn" style={{ marginTop:'0',marginLeft: '10px',  width: '100%', borderRadius: '6px',  padding: '10.5px', maxWidth: '90px' }} onClick={() => handleclearsearch()}>Clear Filter</button>
                            : ''}
                </div>

                <div className="col-sm-2" style={{ float: 'right', textAlign: 'end' }}>
                    <button className="btn btn-primary" style={{ width: '100%', padding: '12.5px', maxWidth: '90px' }} onClick={() => handleAddPopup(true)}><AddCircleIcon style={{ marginBottom: '-3px' }} /> Add</button>
                </div>
            </div>
            <hr />

            <div className="row">
                <div className="col-xs-12">
                    {
                        FilterData && FilterData?.length > 0 ?
                            <div>
                                <div className='AssignmentRule-table'>
                                    <table className='table-logs'>
                                        <thead>
                                            <tr>
                                                <th>Rule Name</th>
                                                <th>Priority</th>
                                                <th>Application Status</th>
                                                <th>Product Criteria</th>
                                                <th>Location Criteria</th>
                                                <th>Pincode Criteria</th>
                                                <th>Min-Value Criteria</th>
                                                <th>Max-Value Criteria</th>
                                                <th>Min-Salary Criteria</th>
                                                <th>Max-Salary Criteria</th>
                                                <th>Min DPD</th>
                                                <th>Max DPD</th>
                                                <th>Overdue Amount</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                FilterData?.map((value, idx) => {
                                                    return (
                                                        <tr key={idx}>
                                                            <td className='text-center' style={{ padding: '10px' }}>{value?.ruleId || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{value?.priority || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{value?.applicationStatus || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{value?.productCriteria || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{value?.locationCriteria || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{convertarrtostr(value?.pincodeCriteria) || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{(Number(value?.minValueCriteria))?.toLocaleString('en-IN') || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{(Number(value?.maxValueCriteria))?.toLocaleString('en-IN') || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{(Number(value?.minSalaryCriteria))?.toLocaleString('en-IN') || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{(Number(value?.maxSalaryCriteria))?.toLocaleString('en-IN') || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{value?.minDpd || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{value?.maxDpd || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>{(Number(value?.overdueAmount))?.toLocaleString('en-IN') || "-"}</td>
                                                            <td className='text-center' style={{ padding: '10px' }}>
                                                                <MenuBar
                                                                    ListType={value}
                                                                    onDelete={() => {
                                                                        handleDelete(value)
                                                                    }}
                                                                    onActivate={() => {
                                                                        handleActivate(value)
                                                                    }}
                                                                    onEdit={() => {
                                                                        handleEditValues(value)
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ marginTop: '10px', float: "right" }}>
                                    <Pagination shape="rounded"
                                        count={Math.ceil(apiData?.length / itemsPerPage)}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                    />
                                </div>
                            </div>
                            : ''}
                </div>
            </div>

            {
                addPopup ?
                    <AddRulesPopup handleAddPopup={handleAddPopup} EditData={Editdata} />
                    : ''}
        </>
    )
}
